<script>
export default {
  name: "termsAndConditionsContent",
  beforeUpdate() {
    document.title = "UNIFI Property: Terms and Conditions";
  },
}
</script>

<template>
  <el-row
    style="padding: 30px 15px 30px 15px; background-color: #fff; margin: 0"
  >
    <el-col :span="24">
      <el-row>
        <el-col :span="24">
          <span class="about-unifi-title">Terms and Conditions</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 16px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400"
          >This Website and its contents are owned or licensed by UNIFI AUSTRALIA Pty Ltd (ACN 669 133 377)
(UNIFI, we, us or our).
          </span>
          <br />
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400 mt-12 t-underline"
          >AGREEMENT TO TERMS AND CONDITIONS
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400">To the maximum extent permitted by law, these terms and conditions govern the use of this Website, the
placement of any Reservations and the purchase of any Services via this Website. We may amend these
Terms and Conditions from time to time and if any part of them is illegal or unenforceable at law, it may
be severed and the remaining Terms and Conditions will continue in full force and effect. </span>
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400 mt-12 t-underline"
          >AMENDMENTS TO THESE TERMS AND CONDITIONS
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400">For future orders of our Services and Reservations that You place with us, these Terms and Conditions
may be different. We recommend that you read these Terms and Conditions carefully each time You visit
our Website, order our Services or place a Reservation. We will not change any Terms and Conditions for
an existing Services order or a Reservation that we have accepted; the Terms and Conditions that will
apply to the Reservation or Service are the Terms and Conditions that applied at the time You placed the
Reservation or ordered the Service. </span>
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400 mt-12 t-underline"
          >DEFINITIONS
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400">In these Terms and Conditions: </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">Available Properties</span> means residential or commercial properties offered for sale Prospective
Property Purchasers by Agents, as agents of the registered proprietors of those properties.</span>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">Claim</span> means any claim, action, proceeding, loss, damage, suit, cause of action, demand, cost,
expense or liability, brought, made or recovered against a person, howsoever arising, whether: </span>
            <ul>
              <li class="about-unifi-para font-w400">
                <span style="margin-left: 10px">a) in contract, tort or otherwise; or </span>
              </li>
              <li class="about-unifi-para font-w400">
            <span style="margin-left: 10px">b) presently ascertained, immediate, future or contingent. </span>
              </li>
            </ul>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">Co-Agent</span> means a third party agent who has been appointed to sell or otherwise deal with an
Available Property on behalf of the registered proprietor.</span>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">Commercialise in relation to Intellectual Property Rights,</span> means to:</span>
            <ul>
              <li class="about-unifi-para font-w400">
                <span style="margin-left: 10px">a) manufacture, sell, hire or otherwise exploit a product or process, that incorporates any of
the Intellectual Property Rights;  </span>
              </li>
              <li class="about-unifi-para font-w400">
                <span style="margin-left: 10px">b) provide a service using any of those Intellectual Property Rights; </span>
              </li>
              <li class="about-unifi-para font-w400">
                <span style="margin-left: 10px">c) license any third party to do any of those things, regardless of whether any revenue is
generated.</span>
              </li>
            </ul>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">Confidential Information</span> means information concerning UNIFI or any of its Related Bodies
Corporate, including details of:</span>
            <ul>
              <li class="about-unifi-para font-w400">
                <span style="margin-left: 10px">a) any past, current or prospective purchasers of residential or commercial properties;  </span>
              </li>
              <li class="about-unifi-para font-w400">
                <span style="margin-left: 10px">b) any suppliers, contractors or agents; </span>
              </li>
              <li class="about-unifi-para font-w400">
                <span style="margin-left: 10px">c) business dealings, methodologies, marketing techniques or market analysis; </span>
              </li>
              <li class="about-unifi-para font-w400">
                <span style="margin-left: 10px">d) financial arrangements with purchasers, suppliers, contractors or agents; </span>
              </li>
              <li class="about-unifi-para font-w400">
                <span style="margin-left: 10px">e) information disclosed on the Property Platform; and  </span>
              </li>
              <li class="about-unifi-para font-w400">
                <span style="margin-left: 10px">f) any other information that is by its nature confidential, is reasonably designated by UNIFI
as confidential or which You know or ought to know is confidential, but does not include
information: </span>
                <ul>
                  <li class="about-unifi-para font-w400">
                    <span style="margin-left: 20px">i. in the public domain, unless it came into the public domain due to a breach of
these Terms and Conditions or some other obligation of confidentiality;</span>
                  </li>
                  <li class="about-unifi-para font-w400">
                    <span style="margin-left: 20px">ii. that is already lawfully in Your possession without restriction, before it was
disclosed by UNIFI; or</span>
                  </li>
                  <li class="about-unifi-para font-w400">
                    <span style="margin-left: 20px">iii. that You obtained lawfully from a third party, without any breach of confidentiality.</span>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">GST</span> means the tax payable on taxable supplies under the A New Tax System (Goods and
Services Tax) Act 1999 (Cth), including any subordinate legislation.</span>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">Intellectual Property Rights</span> means all industrial and intellectual property rights anywhere in the
world, whether registered or unregistered, including patent rights, trade mark rights, copyright
(but excluding Moral Rights), plant breeders’ rights and rights in relation to inventions, trade
names, business names, company names, indications of origin, designs, plant varieties,
semiconductors, circuit layouts, confidential information or know-how, any right of registration,
renewal and extension of such rights and all other intellectual property as defined in article 2 of
the Convention Establishing the World Intellectual Property Organisation 1967.</span>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">Moral Rights</span> means moral rights as described in Part IX of the Copyright Act 1968 (Cth) and any
analogous rights arising under statute that exist, or may come to exist, anywhere in the world.</span>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">Personal Information</span> means information or an opinion about an identified individual, or
information from which an individual could reasonably be identified. This is regardless of
whether the information or opinion is true, and whether or not it is stored in a material or
intangible form.</span>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">Privacy Policy</span> means the privacy policy of UNIFI as displayed on this Website from time to time.</span>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">Property Platform</span> means the electronic platform which allows the consumer and Referral
Partners with a valid Referral Account to access information on Available Properties, including: </span>
            <ul>
              <li class="about-unifi-para font-w400">
                <span style="margin-left: 10px">a) purchase prices;</span>
              </li>
              <li class="about-unifi-para font-w400">
                <span style="margin-left: 10px">b) dimensions, land size and floor plans; and</span>
              </li>
              <li class="about-unifi-para font-w400">
                <span style="margin-left: 10px">c) a description of the Available Property features. </span>
              </li>
            </ul>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">Prospective Property Purchaser</span> means an individual or entity interested in obtaining details of
the Available Properties, with a view to a possible purchase of one or more of them.</span>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">Referral Account</span> means an online record of information:</span>
            <ul>
              <li class="about-unifi-para font-w400">
                <span style="margin-left: 10px">a) created by a Referral Partner;</span>
              </li>
              <li class="about-unifi-para font-w400">
                <span style="margin-left: 10px">b) containing the company name, Australian Business Number, street or PO Box address,
email address and telephone number of the Referral Partner; and</span>
              </li>
              <li class="about-unifi-para font-w400">
                <span style="margin-left: 10px">c) which permits the Referral Partner to access details of Available Properties and to place
orders for Services.</span>
              </li>
            </ul>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">Referral Partner</span> means a third party that may refer Prospective Property Purchasers to its CoAgent.</span>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">Related Bodies Corporate</span> has the same meaning as set out in the Corporations Act 2001 (Cth).</span>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">Reservation</span> means an agreement formed upon processing of the Reservation Fee, under which a
Prospective Property Purchaser reserves an Available Property from viewing by other Referral
Partners on the Property Platform, for the Reservation Period.</span>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">Reservation Fee</span> e means the fee paid by or on behalf of a Prospective Property Purchaser to
secure a Reservation.</span>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">Reservation Period</span> means a period of seven (7) days from the payment of the Reservation Fee, or
such longer period as may be agreed between You and UNIFI. The reservation fee is fully refunded to the consumer after a 7 day holding period. Please note that it may take 3-5 business
days for the reimbursed funds to clear in your account. Any additional transactional fee for
domestic and international cards is a non-refundable fee.</span>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">Services</span> means any of: </span>
            <ul>
              <li class="about-unifi-para font-w400">
            <span style="margin-left: 10px">a) a Reservation; </span>
              </li>
              <li class="about-unifi-para font-w400">
            <span style="margin-left: 10px">b) training materials, modules or activities accessible from our Website from time to time;
and </span>
              </li>
              <li class="about-unifi-para font-w400">
            <span style="margin-left: 10px">c) any other services which may be purchased or made available from this Website from
time to time. </span>
              </li>
            </ul>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">Terms and Conditions</span> means residential or commercial properties offered for sale Prospective
Property Purchasers by Agents, as agents of the registered proprietors of those properties.</span>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">Third Party Fees</span> means the fees described in paragraph (f) of the PLACEMENT OF
RESERVATIONS AND PURCHASE OF OTHER SERVICES FROM OUR WEBSITE section of these
Terms and Conditions. </span>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">Website</span> means the website situated at unifiproperty.com and includes the Property Platform. </span>
          </li>
          <li class="about-unifi-para font-w400">
            <span>&#x2022; <span class="font-w700 t-italic">You</span> means any of a Consumer, Referral Partner or other third party that accesses our Website,
as the context requires and Your or Yourself has a corresponding meaning.</span>
          </li>
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400 mt-12 t-underline"
          >USE OF THIS WEBSITE
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400">You may only use this Website if You:</span>
          <ul>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">a) are aged 18 years or over;</span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">b) are authorised by Prospective Property Purchasers to create a Reservation of Available
Properties on their behalf; and</span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">c) agree to be bound by, and accept, these Terms and Conditions.</span>
            </li>
          </ul>
            <span class="about-unifi-para font-w400">Please immediately exit this Website if You do not satisfy these requirements.</span>
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400 mt-12 t-underline"
          >PLACEMENT OF RESERVATIONS AND PURCHASE OF OTHER SERVICES FROM OUR WEBSITE
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <span class="about-unifi-para font-w400">You agree that: </span>
          <ul>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">a) both You and any Prospective Property Purchaser for whom you act are aged 18 years or over;</span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">b) if You place a Reservation or an order for Services on our Website, You enter into a contract with
UNIFI for the supply of the Reservation or those Services. Each accepted order is a separate
contract; </span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">c) we can accept or reject a Reservation or order for Services for reasons which include
unavailability of the Available Properties or Services (as the case may be), an error in the pricing
or description of the Available Properties or Services, or an error in Your Reservation or order for
the Services;</span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">d) Creating a Account; placing a Reservation; or ordering any Services, must be accurate, complete
and up to date, and You will promptly notify us of any changes to this information or data; </span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">e) all prices quoted for the Reservation Fee or Services are displayed in Australian Dollars (AUD)
and are inclusive of GST;</span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">f) once You have placed Your Reservation or order for Services, You may effect payment by either
Mastercard or Visa. Please note that by using the payment facilities provided by third party ecommerce facilities or credit card merchants, You will be subject to additional terms, conditions,
fees and charges imposed by those third parties;</span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">g) the payment system on this Website uses industry standard Secure Socket Layer (SSL)
technology to encrypt and protect Your credit card details</span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">h) we will provide Your Reservation or Services after Your payment has been processed. For the
avoidance of doubt, we do not offer for sale, or sell Available Properties, but simply make them
available for viewing on our Property Platform; </span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">i) we will use our reasonable endeavours to ensure that Available Properties are available for
purchase or Services are available for delivery, and in most cases the referral partner will notify
You if Available Properties are no longer available before You place Your Reservation, or Services
are unavailable before You order them. In some cases, this will not be possible and we will need
to reject a Reservation for Available Properties or an order for Services after we have processed
Your payment. In these cases, we will refund You in full all amounts You have paid for the
Reservation or unavailable Services, less the Third Party Fees; </span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">j) if you cancel Your Reservation before the Reservation Period expires, we will refund the
Reservation Fee to You, less the Third Party Fees; </span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">k) once the Services have been delivered, You assume all risk and title in the Services.</span>
            </li>
          </ul>
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400 mt-12 t-underline"
          >THIRD PARTY LINKS AND ADVERTISING
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400">Our platform often includes advertisements, hyperlinks and pointers to websites operated by third
parties. Links to third party websites include, without limitation, links to our platform or some of our real
estate agency customers. Those third party websites do not form part of our platform and are not under
the control of or the responsibility of UNIFI. When you link to those websites you leave our platform and
do so entirely at your own risk. UNIFI and its related entities make no warranty as to the accuracy or
reliability of the information contained on any third party websites, and UNIFI and its related entities,
directors, officers and agents disclaim all liability and responsibility for any direct or indirect loss or
damage which may be suffered by you through relying on anything contained on or omitted from such
third party websites. A display of advertising does not imply an endorsement or recommendation by
UNIFI.</span>
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400 mt-12 t-underline"
          >CONTRIBUTIONS
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400">In this section ‘Contributions’, means information including data, text, video, still images, audio or other
material that UNIFI has permitted you to host, share, publish, post, store or upload on our platform as
permitted under these terms. UNIFI may at any time, without liability to you, remove, alter or disable
access to any or all of your Contributions in its sole discretion without prior notice to you. </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400 mt-10">Without limiting the previous sentence, UNIFI may remove or disable access to any or all your
Contributions if it considers that:</span>
          <ul>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">a) those Contributions are in breach of any law or regulation;</span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">b) those Contributions infringe the intellectual property rights of any third party;</span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">c) it is required to do so by a regulatory body or any relevant authority pursuant to an interim or
final take-down notice;</span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">d) those Contributions are: </span>
              <ul>
                <li class="about-unifi-para font-w400">
                    <span style="margin-left: 20px">i. misleading or deceptive;</span>
                </li>
                <li class="about-unifi-para font-w400">
                    <span style="margin-left: 20px">ii. inappropriate having regard to the purpose of our platform;</span>
                </li>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">iii. likely to cause offence;</span>
                </li>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">iv. materially incorrect;</span>
                </li>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">v. obscene;</span>
                </li>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">vi. defamatory;</span>
                </li>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">vii. otherwise unlawful; or</span>
                </li>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">viii. corrupted, due to the presence of a virus or other disabling code.</span>
                </li>
              </ul>
            </li>
          </ul>
          <span class="about-unifi-para font-w400">You retain all of your ownership rights in your Contributions. UNIFI is under no obligation to treat your
Contributions as proprietary information.</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400">To the extent that any Contributions are proprietary in nature, you grant UNIFI a worldwide, nonexclusive,
royalty-free, perpetual, transferable and irrevocable licence to use, reproduce, modify, adapt, translate,
distribute, publish, create derivative works from and display and publicly perform your Contributions
throughout the world in any medium, whether currently in existence or not. You also grant each user of
our platform a nonexclusive licence to use, reproduce, adapt, translate, distribute, prepare derivative
works of, display and perform your Contributions as permitted by UNIFI and these terms. </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <span class="about-unifi-para font-w400">You grant UNIFI, in respect of Contributions to its website the right to use your name or the name you
submit with the Contribution, and, the right to represent and warrant that: </span>
          <ul>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">a) you own and control all of the rights to the Contributions; or </span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">b) you have the lawful right including all necessary licences, rights, consents, and permissions to
use and authorise UNIFI to display the Contributions. </span>
            </li>
          </ul>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <span class="about-unifi-para font-w400">For any Contributions that you may retain moral rights in, you declare that:</span>
          <ul>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">a) you do not require that any personally identifying information be used in connection with the
Contribution, or any derivative work, upgrade or update of the Contribution; and </span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">b) You understand that when accessing our platform, you may be exposed to the Contributions of
other users of our platform. You acknowledge and agree that UNIFI does not have control of and
is not responsible for these other Contributions. You release UNIFI from any claims that you
could assert against UNIFI relating to or in connection with these other Contributions. </span>
            </li>
          </ul>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <span class="about-unifi-para font-w400">You represent and warrant that: </span>
          <ul>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">a) you have the lawful right including all necessary licences, rights, consents, and permissions to
use and authorise UNIFI to display your Contributions; and </span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">b) you will not make any Contributions that: </span>
              <ul>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">i. infringe the intellectual property rights of any third party, and you agree to pay all
royalties, fees or other monies payable by reason of any Contributions made by
you; </span>
                </li>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">ii. are misleading or deceptive;</span>
                </li>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">iii. are materially incorrect;</span>
                </li>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">iv. are likely to cause offence;</span>
                </li>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">v. directly or indirectly involve the advertising or marketing of any products or
services;</span>
                </li>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">vi. are obscene, including pornographic, hateful, racially or ethnically offensive
material;</span>
                </li>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">vii. are defamatory;</span>
                </li>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">viii. are otherwise unlawful or encourage unlawful conduct; or</span>
                </li>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">ix. are otherwise inappropriate having regard to the purpose of our platform.</span>
                </li>
              </ul>
            </li>
          </ul>
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400 mt-12 t-underline"
          >YOUR REFERRAL ACCOUNT
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <span class="about-unifi-para font-w400">When placing Reservations or purchasing Services via this Website, You will need to create a Referral
Account with us. </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <span class="about-unifi-para font-w400">To create a Referral Account, You must: </span>
          <ul>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">a) be aged 18 years or over and have the capacity to enter into a binding legal agreement to create a
Referral Account with us; </span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">b) provide us with, amongst other matters, Your company name, Australian Business Number,
street or PO Box address, email address and telephone number. All Personal Information that we
receive from You is handled in accordance with the practices set out in our Privacy Policy which
is accessible from this Website; and </span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">c) create a password and username at the time that You register a Referral Account with us. You
are responsible for maintaining the security of Your username and password. If You suspect that
Your account has been subject to unauthorised access, You must contact us immediately and
take reasonable steps to secure Your account, such as changing Your password. We are not
liable for any Claims howsoever arising from the unauthorised use of Your password or
username.</span>
            </li>
          </ul>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <span class="about-unifi-para font-w400">We reserve the right to terminate or suspend Your account in the event that you breach these Terms and
Conditions.</span>
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400 mt-12 t-underline"
          >YOUR PERSONAL INFORMATION AND PRIVACY
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400">Our Privacy Policy sets out the ways in which we may collect, store, use and manage Your Personal
Information, and the physical and electronic measures we will take to protect Your Personal Information.
By supplying us with Personal Information through this Website, You accept the inherent security risk of
dealings online over the internet and agree not to hold us responsible for any breach of security, unless
we have breached a law or been in wilful default of our duties to You. </span>
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400 mt-12 t-underline"
          >OUR INTELLECTUAL PROPERTY RIGHTS
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400">Unless expressly stated otherwise, we own or are licensed to use all Intellectual Property Rights in this
Website and its content. You may only use that content with our express written consent or as permitted
under applicable Australian and international laws. If we allow You to use any of the content appearing on
this Website, our status as the owner or licensee of the Intellectual Property Rights in that content must
be publicly acknowledged in writing, as we may direct. In that respect, You must not:</span>
          <ul>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">a) adapt, modify, reproduce or transmit any of the Website content (including its graphics, layouts
and format) without our prior written consent; </span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">b) frame our Website content within Your own website, without our prior written consent; </span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">c) download our Website content for any purpose other than referring Prospective Property
Purchasers or its Co-Agent. </span>
            </li>
          </ul>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400">We do not own or license, and we take no responsibility for trade marks, logos, design and copyright
material appearing in:</span>
          <ul>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">a) any third party websites which may be accessible from links displayed on our Website; or</span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">b) content that You provide to us. </span>
            </li>
          </ul>
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400 mt-12 t-underline"
          >COPYRIGHT
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400">The subject matter on and accessible from our platform and publications is protected by copyright. Apart
from fair dealing permitted by the Copyright Act 1968, UNIFI grants visitors to the site permission to
download copyright material only for private and non-commercial purposes. For reproduction or use of
unifiproperty.com copyright material beyond such use, written permission must be obtained directly
from UNIFI or the relevant copyright owner. If given, permission will be subject to the requirement that the copyright owner’s name and interest in the material be acknowledged when the material is
reproduced or quoted, in whole or in part.</span>
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400 mt-12 t-underline"
          >CONFIDENTIAL INFORMATION
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400">Some sections of this Website, including the Property Platform, contain Confidential Information. By
accessing this Website, You acknowledge and agree that:</span>
          <ul>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">a) we are providing You with access to the Confidential Information to facilitate Your referral of
Prospective Property Purchasers, referral partners or its Co-Agents; </span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">b) You will not use or disclose the Confidential Information for any other purpose, including to:</span>
              <ul>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">i. improperly gain an advantage for Yourself or someone else;</span>
                </li>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">ii. cause detriment to UNIFI Australia, Referral Partners or its Co-Agent; </span>
                </li>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">iii. solicit, canvass or approach any of the registered proprietors of the Available
Properties, so as to induce them to cease the appointment of UNIFI or its Referral
Partners and CoAgents;</span>
                </li>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">iv. interfere with the relationship between registered proprietors of the Available
Properties and UNIFI or its Referral Partners and Co-Agent; and</span>
                </li>
              </ul>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">c)  the restrictions and prohibitions outlined in this section are reasonable in the circumstances and
necessary to protect the goodwill in UNIFI’s, Referral Partners and its Co-Agent’s business; and</span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">d) monetary damages alone are not an adequate remedy for breach of this section and UNIFI may
apply for injunctive relief if You breach or threaten to breach this section. </span>
            </li>
          </ul>
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400 mt-12 t-underline"
          >CONTENT WE PROVIDE
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <li class="about-unifi-para font-w400">
            <span>Unless stated otherwise, we grant to You a personal, nontransferable, revocable and non-exclusive
licence to use any files that we expressly state is available for download on this Website, for Your own
personal use. Unless permitted by a written agreement between You and us, You must not copy,
communicate to the public, modify, reverse engineer, or otherwise transfer any right in those files. We
cannot guarantee that information (including any file) obtained from this Website is free from computer
viruses, other faults or defects. It is Your responsibility to scan the information for computer viruses and
You assume the risk of any damage to Your computer and associated equipment arising from the use of
this Website or the downloading of any files from it. </span>
          </li>
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400 mt-12 t-underline"
          >CONTENT YOU PROVIDE
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <li class="about-unifi-para font-w400">
            <span>You are fully responsible for any content (including any testimonials, comments, suggestions, graphics or
other material) that You provide to us for display on the Website. By providing content to us, You grant us
a licence to use that content without payment or reference to You, for purposes which include advertising
or marketing our own business and services.</span>
          </li>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <li class="about-unifi-para font-w400">
            <span>You agree that You will not use this Website to post or display content that: </span>
            <ul>
              <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">a) You do not have the right to post or display;</span>
              </li>
              <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">b) violates the Intellectual Property Rights, confidentiality, privacy or other rights of any person or
entity;</span>
              </li>
              <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">c) violates consumer protection or fair trading laws; </span>
              </li>
              <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">d) is offensive, abusive, defamatory, discriminatory, false or misleading; </span>
              </li>
              <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">e) comprises advertising or promotional materials of any kind; or </span>
              </li>
              <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">f) contains software viruses or anything harmful to this Website or to the computers, mobile
devices or associated equipment of other users of this Website. </span>
              </li>
            </ul>
            <span>We reserve the right to edit or remove any of Your content at any time, without providing any reasons. </span>
          </li>
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400 mt-12 t-underline"
          >LINKS TO EXTERNAL WEBSITES
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400">Our Website may contain links to Websites or advertisements of goods and services available from third
parties. We are not responsible for the content of those Websites or advertisements, or any goods or
services made available on them.</span>
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400 mt-12 t-underline"
          >SOCIAL MEDIA
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400">We maintain a presence on Facebook, Instagram, LinkedIn and X, but are not endorsed by, or affiliated
with, those organisations (Social Media Accounts).</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400">We reserve the right to remove any material that is posted on the pages of our Social Media Accounts
that:</span>
          <ul>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">a) is abusive, defamatory, offensive or threatening towards us, our employees or any other person
or organisation; </span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">b) breaches the terms and conditions of any of the providers of the Social Media Accounts;</span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">c) constitutes spruiking or other advertising, unless written consent has been obtained from us to
post such material; or </span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">d) relates to any illegal activity. </span>
            </li>
          </ul>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400">Please note that You will be subject to, and agree to comply with, the respective terms and conditions
imposed by Facebook, Instagram, LinkedIn, X and Twitter whilst You are visiting any of our Social Media
Accounts and it remains Your responsibility to familiarise Yourself with those terms and conditions. </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400">By embedding an X timeline on our Website, X is granted a non-exclusive, royalty free licence to access,
index and cache this Website by any means, including web spiders and/or crawlers. X use of cookies may
involve the storing and accessing of cookies or other information on Your devices, as described in Xs
Cookie Use Policy. You should consider X’s Cookies Use Policy before using our Website, which can be
viewed via: <a href="https://help.x.com/en/rules-and-policies/x-cookies">https://help.x.com/en/rules-and-policies/x-cookies</a></span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400">X’s use of cookies may result in X collecting and storing data about Your browsing activities, including for
interest based advertising. By proceeding to use our Website, You consent to X’s use of cookies. You may
opt out of X’s interest-based advertising and personalisation in accordance with the instructions
              contained in its X for Websites — ads info and privacy document, accessible via: <a href="https://help.x.com/en/xfor-websites-ads-info-and-privacy">https://help.x.com/en/xfor-websites-ads-info-and-privacy</a></span>
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400 mt-12 t-underline"
          >LIMITATION OF LIABILITY
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <span class="about-unifi-para font-w400">To the maximum extent permitted by law, including the Australian Consumer Law: </span>
          <ul>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">a) we provide this Website on an “as is” basis. We may suspend access to our Website or close it
indefinitely without notice and You accept the inherent security and reliability risks of dealings on
the internet;</span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">b) we are not liable for loss of revenue, loss of actual or anticipated profits, loss of business or
indirect and consequential losses;</span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">c) we are not liable for a breach of our obligations under these Terms and Conditions which has
resulted from causes beyond our reasonable control. Those causes include extreme weather
conditions, government restrictions, declared epidemics or pandemics, industrial strikes and
failure of equipment or machinery, including failure of the internet; and</span>
            </li>
            <li class="about-unifi-para font-w400">
              <span style="margin-left: 10px">d) subject to the Australian Consumer Law (and without excluding any mandatory statutory
guarantees contained within the Australian Consumer Law or other statutory rights which cannot
be excluded by contract) all conditions, warranties and implied terms are excluded from these
Terms and Conditions. To the extent that we breach these Terms and Conditions and it is legally
permissible to do so, our liability is limited to:</span>
              <ul>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">i. replacement of the Services supplied or supply of equivalent Services;</span>
                </li>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">ii. payment of the cost of replacing the Services or acquiring equivalent Services;</span>
                </li>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">iii. supply of the Services again; or</span>
                </li>
                <li class="about-unifi-para font-w400">
                  <span style="margin-left: 20px">iv. in the case of Reservations, a refund of the Reservation Fee, less the Third Party
Fees. </span>
                </li>
              </ul>
            </li>
          </ul>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400">We will take all reasonable steps to ensure that this Website is accurate, but make no representation as
to the appropriateness of it for Your personal circumstances.</span>
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400 mt-12 t-underline"
          >NOTICES
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400">We may give notice to You by electronic mail or by regular mail to the address contained in Your Referral
Account or other information You have provided. Our Privacy Policy explains how You can opt-out of
receiving such notices.</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="about-unifi-para font-w400 mt-12 t-underline"
          >GOVERNING LAW
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
            <span class="about-unifi-para font-w400">The laws of South Australia, Australia, govern these Terms and Conditions and the courts of South
Australia have non-exclusive jurisdiction to hear any matters arising from or in connection with these
Terms and Conditions.</span>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<style scoped>
.about-unifi-title {
  color: #003333;
  font-family: DINosaur-a, sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.about-unifi-para {
  color: #003333;
  font-family: DINosaur-a, sans-serif;
  font-size: 16px;
  font-style: normal;
  line-height: 125%;
}
.el-collapse-item /deep/ .el-collapse-item__header {
  background-color: #2d2d2d;
  color: #f5f5f5;
}
.el-collapse-item /deep/ .el-collapse-item__wrap {
  background-color: #2d2d2d;
}
.el-collapse-item /deep/ .el-collapse-item__content {
  color: #f5f5f5;
}
.font-w400 {
  font-weight: 400;
}
.font-w700 {
  font-weight: 700;
}
.t-underline {
  text-decoration: underline;
}
.t-italic {
  font-style: italic;
}
.mt-10 {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/terms/termsAndConditionsContent.vue